export enum ActionTypes {
  GET_TASKS_REQUEST = '@@task/GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS = '@@task/GET_TASKS_SUCCESS',
  GET_TASKS_FAILURE = '@@task/GET_TASKS_FAILURE',

  DELETE_TASK_REQUEST = '@@task/DELETE_TASK_REQUEST',
  DELETE_TASK_SUCCESS = '@@task/DELETE_TASK_SUCCESS',
  DELETE_TASK_FAILURE = '@@task/DELETE_TASK_FAILURE',
}
